<div class="d-flex align-items-center">
    <a class="text-decoration-none" ngbTooltip="View details" style="margin-right:24px;margin-bottom: 4px;" (click)="onViewClick()"><img [src]='eyeview'></a>
    <a class="text-decoration-none" (click)="onDeleteClick()" ><i class="nxticon-delete-new nxt-font-20"></i></a>
</div>